/**
 * Riquadro «Dati della pratica» nel dettaglio della richiesta dell'associato
 * (canale «Documento Unico»): etichetta e valore, in sola lettura, ogni valore
 * copiabile; la targa in monospace. Non si rende nulla se il ticket non ha
 * campi ne valori (server di prima, canali senza campi).
 */
import React from 'react';
import { Copy } from 'lucide-react';
import { useToast } from '../../../contexts/ToastContext';
import { CHIAVE_MONOSPACE, copiaNegliAppunti, righeDatiPratica } from '../campiPratica';

interface Props {
  /** Dettaglio del ticket: legge `campiRichiesta` e `campiExtra` se ci sono. */
  ticket: object;
  className: string;
  labelClassName: string;
}

const DatiPraticaCard: React.FC<Props> = ({ ticket, className, labelClassName }) => {
  const toast = useToast();
  const righe = righeDatiPratica(ticket);
  if (righe.length === 0) return null;

  const copia = async (etichetta: string, valore: string) => {
    if (await copiaNegliAppunti(valore)) toast.success(`${etichetta} copiato`);
    else toast.error('Copia non riuscita: seleziona il testo e copialo a mano');
  };

  return (
    <section className={className} aria-labelledby="dati-pratica-titolo">
      <p id="dati-pratica-titolo" className={`${labelClassName} mb-3`}>Dati della pratica</p>
      <dl className="space-y-2 text-sm">
        {righe.map((r) => (
          <div key={r.chiave} className="flex items-start justify-between gap-3">
            <dt className="text-xs text-gray-500 dark:text-gray-400 shrink-0">{r.etichetta}</dt>
            <dd className="min-w-0 flex items-center justify-end gap-1.5 text-right">
              {r.valore ? (
                <>
                  <span
                    className={`text-sm text-gray-900 dark:text-gray-100 break-all select-all${r.chiave === CHIAVE_MONOSPACE ? ' font-mono' : ''}`}
                  >
                    {r.valore}
                  </span>
                  <button
                    type="button"
                    onClick={() => copia(r.etichetta, r.valore)}
                    aria-label={`Copia ${r.etichetta}`}
                    title="Copia"
                    className="p-1 shrink-0 rounded text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                  >
                    <Copy className="w-3.5 h-3.5" aria-hidden="true" />
                  </button>
                </>
              ) : (
                <span className="text-sm text-gray-400 dark:text-gray-500">—</span>
              )}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
};

export default DatiPraticaCard;
